<template>
  <!-- 横向表格组件 -->
  <div class="corssTable">
    <table border="1" cellspacing="0" cellpadding="0" :width="tableConfig.width.table_width">
      <tr v-for="(th_data , index) in tableConfig.columns" :key="index">
        <th :width="tableConfig.width.head_width">{{th_data.title}}</th>
        <td
          v-for="(td_data , index) in tableConfig.data"
          :key="index"
          :style="td_style(td_data)"
        >{{td_data[th_data.key]}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'CorssTable',
  data() {
    return {

    }
  },
  props: {
    tableConfig: {
      type: Object
    }
  },
  methods: {
    td_style(val) {
      if (val.color_style == 'big') {
        return 'background:#90C185'
      } else if (val.color_style == 'equal') {
        return 'background:#F3D17C'
      } else if (val.color_style == 'small') {
        return 'background:#DEDEDE'
      }
    }
  }
}
</script>

<style lang='less'>
.corssTable {
  table {
    box-sizing: border-box;
    text-align: center;
    border: 1px solid #dcdee2;
    padding: 5px 10px;
    tr {
      th {
      }
      td {
        padding: 5px 0;
      }
    }
  }
}
</style>